(function registerSpatialxDjDeck(global) {
  'use strict';

  if (global.SpatialxDjDeck) {
    global.SpatialxDjDeck.mount(document);
    return;
  }
  var instance = null;

  function mount(scope) {
    scope = scope && scope.querySelector ? scope : document;
    var root = scope.id === 'dj-deck-page' ? scope : scope.querySelector('#dj-deck-page');
    if (!root || (instance && instance.root === root)) return;
    var section = root.closest('[id^="shopify-section-"]') || root.parentElement;
    var dataNode = section.querySelector('#SpatialxDjDeckTracks');
    if (!dataNode) return;
    destroy();
    var release = createInstance(root, dataNode);
    if (release) instance = { root: root, release: release };
  }

  function destroy(scope) {
    if (!instance || (scope && scope !== instance.root && !scope.contains(instance.root))) return;
    var previous = instance;
    instance = null;
    previous.release();
  }

  function createInstance(root, dataNode) {

  var tracks = [];
  try { tracks = JSON.parse(dataNode.textContent || '[]'); } catch (_) {}
  tracks = tracks.filter(function (track) { return track && track.id && track.previewUrl; });
  if (!tracks.length) {
    var statusNode = document.getElementById('dj-console-status');
    if (statusNode) statusNode.textContent = 'Catalogue signal unavailable';
    return;
  }

  var disposed = false;
  var removers = [];
  var pendingTimers = new Set();
  var previousTextRenderer = global.render_game_to_text;
  function listen(target, name, handler, options) {
    target.addEventListener(name, handler, options);
    removers.push(function () { target.removeEventListener(name, handler, options); });
  }
  function later(handler, delay) {
    if (disposed) return 0;
    var timer = global.setTimeout(function () {
      pendingTimers.delete(timer);
      if (!disposed) handler();
    }, delay);
    pendingTimers.add(timer);
    return timer;
  }
  function cancelLater(timer) {
    global.clearTimeout(timer);
    pendingTimers.delete(timer);
  }
  function assertActive() {
    if (disposed) throw new Error('DJ Deck was unmounted');
  }
  function watchPlayback(deck, resume) {
    if (disposed || !root.isConnected) return false;
    var listeningPass = global.SpatialxListeningPass;
    if (listeningPass && listeningPass.watchMedia) listeningPass.watchMedia(deck.audio, {
      source: 'dj-deck',
      trigger: document.activeElement,
      resume: function () { if (!disposed && root.isConnected) resume(); }
    });
    return true;
  }
  function readSetting(key) {
    try { return localStorage.getItem(key); } catch (_) { return null; }
  }
  function writeSetting(key, value) {
    try { localStorage.setItem(key, value); } catch (_) {}
  }

  document.body.classList.add('dj-deck-page');

  var STORAGE_KEY = 'spatialx-dj-deck-session-v1';
  var PLAYLIST_KEY = 'spatialx-dj-deck-playlist-v1';
  var KEEP_PLAYING_KEY = 'spatialx-dj-deck-keep-playing-v1';
  var MIXER_STATE_VERSION = 2;
  var activeDeckKey = 'a';
  var crossfader = 50;
  var drawerDeckKey = '';
  var drawerReturnFocus = null;
  var audioContext = null;
  var masterGain = null;
  var compressor = null;
  var rafId = 0;
  var loopRunning = false;
  var loopObserver = null;
  var playlist = readJson(PLAYLIST_KEY, []);
  var keepPlaying = readSetting(KEEP_PLAYING_KEY) !== 'false';
  var filters = { search: '', genre: '', bpm: '' };
  var BROWSER_PAGE_SIZE = 10;
  var browserPage = 0;
  var quickLoadGenre = '';
  var quickLoadIds = [];
  var autoMixInProgress = false;
  var autoMixTimer = 0;
  var AUTO_PLAY_KEY = 'spatialx-dj-deck-auto-play-v1';
  var AUTO_PLAY_LEAD_SECONDS = 15;
  var AUTO_PLAY_PRELOAD_DELAY_MS = 10000;
  var autoPlay = readSetting(AUTO_PLAY_KEY) === 'true';
  var autoPlayPreloadTimer = 0;
  var SIMPLE_KEY = 'spatialx-dj-deck-simple-v1';
  var simplePreference = readSetting(SIMPLE_KEY);
  var simpleActive = false;
  var SIMPLE_PAGE_SIZE = 20;
  var simpleVisibleLimit = SIMPLE_PAGE_SIZE;
  var simpleOrderIds = [];
  var mobileQuery = global.matchMedia ? global.matchMedia('(max-width: 740px)') : null;
  var lastPlayedGenre = '';
  var consoleNode = root.querySelector('.dj-console') || root;

  function clamp(value, min, max) { return Math.min(max, Math.max(min, value)); }
  function byId(id) { return root.querySelector('#' + id); }
  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'})[character];
    });
  }
  function readJson(key, fallback) {
    try { return JSON.parse(localStorage.getItem(key) || 'null') || fallback; } catch (_) { return fallback; }
  }
  function writeJson(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) {} }
  function formatTime(seconds) {
    seconds = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0;
    return Math.floor(seconds / 60) + ':' + String(seconds % 60).padStart(2, '0');
  }
  function getTrack(id) { return tracks.find(function (track) { return track.id === id; }) || null; }
  function status(message) { var node = byId('dj-console-status'); if (node) node.textContent = message; }

  function createDeck(key) {
    var host = root.querySelector('[data-deck="' + key + '"]');
    var audio = new Audio();
    audio.preload = 'metadata';
    audio.crossOrigin = 'anonymous';
    return {
      key: key,
      host: host,
      audio: audio,
      track: null,
      volume: 0.84,
      pitch: 0,
      filter: 0,
      cue: 0,
      loopSeconds: 0,
      loopStart: 0,
      source: null,
      filterNode: null,
      gainNode: null,
      analyser: null,
      frequencyData: null,
      autoMixArmedId: '',
      autoPlayFiredId: '',
      loadTimer: 0,
      scratchResume: false,
      scratchX: 0,
      keyLock: true,
      angle: 0,
      liveLevel: 0,
      ui: {
        art: host.querySelector('[data-deck-art]'),
        fallback: host.querySelector('[data-deck-fallback]'),
        title: host.querySelector('[data-deck-title]'),
        artist: host.querySelector('[data-deck-artist]'),
        extra: host.querySelector('[data-deck-extra]'),
        time: host.querySelector('[data-deck-time]'),
        play: host.querySelector('[data-deck-action="play"]'),
        playIcon: host.querySelector('[data-deck-play-icon]'),
        playLabel: host.querySelector('[data-deck-play-label]'),
        eject: host.querySelector('[data-deck-action="eject"]'),
        setCue: host.querySelector('[data-deck-action="set-cue"]'),
        cue: host.querySelector('[data-deck-action="jump-cue"]'),
        sync: host.querySelector('[data-deck-action="sync"]'),
        nudgeBack: host.querySelector('[data-deck-action="nudge-back"]'),
        nudgeForward: host.querySelector('[data-deck-action="nudge-forward"]'),
        cart: host.querySelector('[data-deck-action="cart"]'),
        cartLabel: host.querySelector('[data-deck-cart-label]'),
        progress: host.querySelector('[data-deck-progress]'),
        platter: host.querySelector('[data-deck-platter]'),
        disc: host.querySelector('.dj-platter-disc'),
        wave: host.querySelector('[data-deck-wave]'),
        trackLink: host.querySelector('[data-deck-track-link]'),
        artistLink: host.querySelector('[data-deck-artist-link]'),
        state: host.querySelector('[data-deck-status]'),
        stateLabel: host.querySelector('[data-deck-state-label]'),
        volume: host.querySelector('[data-deck-slider="volume"]'),
        volumeOut: host.querySelector('[data-deck-output="volume"]'),
        filter: host.querySelector('[data-deck-slider="filter"]'),
        filterOut: host.querySelector('[data-deck-output="filter"]'),
        pitch: host.querySelector('[data-deck-slider="pitch"]'),
        pitchOut: host.querySelector('[data-deck-output="pitch"]'),
        keyLockBtn: host.querySelector('[data-deck-keylock]')
      }
    };
  }

  var decks = { a: createDeck('a'), b: createDeck('b') };

  function opposing(deck) { return deck.key === 'a' ? decks.b : decks.a; }
  function crossfaderValue(value, snapToCentre) {
    var next = Number(value);
    if (!Number.isFinite(next)) next = 50;
    next = clamp(next, 0, 100);
    if (snapToCentre && Math.abs(next - 50) <= 3) next = 50;
    return next;
  }
  function setCrossfader(value, options) {
    options = options || {};
    crossfader = crossfaderValue(value, options.snapToCentre !== false);
    var control = byId('dj-crossfader');
    if (control) control.value = String(crossfader);
    applyMix();
    if (options.persist !== false) scheduleSave();
  }
  function ensureDeckAudible(deck) {
    var outsideAudibleRange = deck.key === 'a' ? crossfader > 92 : crossfader < 8;
    if (!outsideAudibleRange) return;
    setCrossfader(opposing(deck).audio.paused ? (deck.key === 'a' ? 0 : 100) : 50);
  }
  function claimAudioFocus(deck) {
    try {
      global.dispatchEvent(new CustomEvent('sx:audio-play', {detail:{source:'dj-deck', deck:deck.key}}));
    } catch (_) {}
  }
  function markActive(deck) {
    activeDeckKey = deck.key;
    root.dataset.activeDeck = deck.key;
    decks.a.host.classList.toggle('is-active-deck', deck.key === 'a');
    decks.b.host.classList.toggle('is-active-deck', deck.key === 'b');
    root.querySelectorAll('[data-mobile-deck]').forEach(function (button) {
      var selected = button.dataset.mobileDeck === deck.key;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    scheduleSave();
  }

  function setAutoMixArm(deck, track) {
    deck.autoMixArmedId = track && track.id ? track.id : '';
    deck.host.classList.toggle('is-auto-mix-armed', !!deck.autoMixArmedId);
    if (deck.autoMixArmedId) deck.host.dataset.autoMixArmed = deck.autoMixArmedId;
    else delete deck.host.dataset.autoMixArmed;
    updateDeck(deck);
  }

  function recommendedLoadDeck() {
    if (!decks.a.audio.paused && decks.b.audio.paused) return decks.b;
    if (!decks.b.audio.paused && decks.a.audio.paused) return decks.a;
    return decks[activeDeckKey];
  }

  async function ensureAudioGraph() {
    assertActive();
    if (audioContext) {
      if (audioContext.state === 'suspended') await audioContext.resume();
      return;
    }
    var Ctor = global.AudioContext || global.webkitAudioContext;
    if (!Ctor) return;
    audioContext = new Ctor();
    masterGain = audioContext.createGain();
    compressor = audioContext.createDynamicsCompressor();
    compressor.threshold.value = -8;
    compressor.knee.value = 18;
    compressor.ratio.value = 5;
    compressor.attack.value = 0.003;
    compressor.release.value = 0.24;
    masterGain.connect(compressor).connect(audioContext.destination);
    Object.keys(decks).forEach(function (key) {
      var deck = decks[key];
      deck.audio.volume = 1;
      deck.source = audioContext.createMediaElementSource(deck.audio);
      deck.filterNode = audioContext.createBiquadFilter();
      deck.filterNode.type = 'allpass';
      deck.gainNode = audioContext.createGain();
      deck.analyser = audioContext.createAnalyser();
      deck.analyser.fftSize = 256;
      deck.frequencyData = new Uint8Array(deck.analyser.frequencyBinCount);
      deck.source.connect(deck.filterNode).connect(deck.analyser).connect(deck.gainNode).connect(masterGain);
      // Tone state set before the graph existed (pad drags, restored
      // sessions) was silently dropped by applyTone's null-node guard —
      // re-apply it now that the filter node is real.
      applyTone(deck);
    });
    applyMix();
  }

  function applyTone(deck) {
    deck.audio.playbackRate = clamp(1 + deck.pitch / 100, 0.82, 1.18);
    // Key Lock = time-stretch (speed changes, musical pitch held). Off =
    // vinyl mode, where speed bends pitch like a turntable.
    try {
      deck.audio.preservesPitch = deck.keyLock !== false;
      deck.audio.webkitPreservesPitch = deck.keyLock !== false;
    } catch (_) {}
    if (!deck.filterNode) return;
    var amount = deck.filter;
    if (Math.abs(amount) < 1) {
      deck.filterNode.type = 'allpass';
      deck.filterNode.frequency.value = 1000;
    } else if (amount < 0) {
      deck.filterNode.type = 'lowpass';
      deck.filterNode.frequency.value = 18000 * Math.pow(0.035, Math.abs(amount) / 100) + 120;
      deck.filterNode.Q.value = 0.7;
    } else {
      deck.filterNode.type = 'highpass';
      deck.filterNode.frequency.value = 25 * Math.pow(240, amount / 100);
      deck.filterNode.Q.value = 0.7;
    }
  }

  function applyMix() {
    var x = clamp(crossfader / 100, 0, 1);
    var gains = { a: Math.cos(x * Math.PI / 2), b: Math.sin(x * Math.PI / 2) };
    var mixPercent = { a: Math.round((1 - x) * 100), b: Math.round(x * 100) };
    Object.keys(decks).forEach(function (key) {
      var deck = decks[key];
      var value = deck.volume * gains[key];
      if (deck.gainNode && audioContext) {
        deck.audio.volume = 1;
        deck.gainNode.gain.setTargetAtTime(value, audioContext.currentTime, 0.018);
      } else deck.audio.volume = clamp(value, 0, 1);
      deck.host.style.setProperty('--deck-mix', gains[key].toFixed(3));
      deck.host.classList.toggle('is-mix-dominant', gains[key] >= 0.88);
      deck.host.classList.toggle('is-mix-muted', gains[key] <= 0.16);
      var fader = byId('dj-channel-fader-' + key);
      if (fader && document.activeElement !== fader) fader.value = String(Math.round(deck.volume * 100));
      var volOut = byId('dj-vol-' + key);
      if (volOut) volOut.textContent = Math.round(deck.volume * 100) + '%';
    });
    var control = byId('dj-crossfader');
    var output = byId('dj-crossfader-output');
    var outputA = byId('dj-mix-a');
    var outputB = byId('dj-mix-b');
    var mode = byId('dj-crossfader-mode');
    if (control) {
      control.value = String(crossfader);
      control.setAttribute('aria-valuetext', 'Deck A ' + mixPercent.a + ' percent, Deck B ' + mixPercent.b + ' percent');
    }
    if (output) output.textContent = 'A ' + mixPercent.a + '% · B ' + mixPercent.b + '%';
    if (outputA) outputA.textContent = mixPercent.a + '%';
    if (outputB) outputB.textContent = mixPercent.b + '%';
    if (mode) mode.textContent = mixPercent.a === mixPercent.b ? 'Centre detent' : mixPercent.a > mixPercent.b ? 'Deck A lead' : 'Deck B lead';
    consoleNode.style.setProperty('--mix-left', String(1 - x));
    consoleNode.style.setProperty('--mix-right', String(x));
    root.dataset.mixFocus = x < 0.47 ? 'a' : x > 0.53 ? 'b' : 'centre';
  }

  function deckMessage(deck, message) { if (deck.ui.state) deck.ui.state.textContent = message; }

  function flashControl(button) {
    if (!button) return;
    button.classList.remove('is-confirmed');
    void button.offsetWidth;
    button.classList.add('is-confirmed');
    later(function () { button.classList.remove('is-confirmed'); }, 520);
  }

  function updateDeck(deck) {
    var track = deck.track;
    if (!track) return;
    var duration = Number.isFinite(deck.audio.duration) ? deck.audio.duration : 0;
    var current = Number(deck.audio.currentTime || 0);
    if (deck.ui.time) deck.ui.time.textContent = formatTime(current) + ' / ' + formatTime(duration);
    if (deck.ui.progress && duration) deck.ui.progress.value = String(Math.round(current / duration * 1000));
    var isPlaying = !deck.audio.paused;
    if (deck.ui.playIcon) deck.ui.playIcon.textContent = isPlaying ? '❚❚' : '▶';
    if (deck.ui.playLabel) deck.ui.playLabel.textContent = isPlaying ? 'On Air' : 'Play';
    if (deck.ui.volumeOut) deck.ui.volumeOut.textContent = Math.round(deck.volume * 100) + '%';
    if (deck.ui.pitchOut) deck.ui.pitchOut.textContent = (deck.pitch >= 0 ? '+' : '') + deck.pitch.toFixed(1) + '%';
    if (deck.ui.filterOut) deck.ui.filterOut.textContent = Math.abs(deck.filter) < 1 ? 'Neutral' : deck.filter < 0 ? 'Low pass' : 'High pass';
    deck.host.classList.toggle('is-playing', isPlaying);
    if (deck.ui.stateLabel) {
      deck.ui.stateLabel.textContent = deck.host.classList.contains('is-track-loading')
        ? 'Loading'
        : isPlaying
          ? 'On air'
          : deck.autoMixArmedId === track.id
            ? 'Next'
            : 'Armed';
    }
    if (deck.ui.play) {
      deck.ui.play.setAttribute('aria-pressed', String(isPlaying));
      deck.ui.play.setAttribute('aria-label', (isPlaying ? 'Pause' : 'Play') + ' Deck ' + deck.key.toUpperCase());
    }
    if (deck.ui.platter) {
      var ratio = duration ? current / duration : 0;
      deck.ui.platter.style.setProperty('--dj-progress', (ratio * 360).toFixed(2) + 'deg');
    }
    if (deck.ui.disc) deck.ui.disc.style.transform = 'rotate(' + deck.angle.toFixed(2) + 'deg)';
    renderSimpleNow();
  }

  function loadTrack(deck, track, options) {
    options = options || {};
    if (!track || !track.previewUrl) return;
    var wasPlaying = !deck.audio.paused;
    deck.scratchResume = false;
    deck.audio.pause();
    deck.track = track;
    setAutoMixArm(deck, options.manual === true ? track : null);
    cancelLater(deck.loadTimer);
    deck.host.classList.remove('is-track-loaded', 'is-track-loading');
    void deck.host.offsetWidth;
    deck.host.classList.add('is-track-loading');
    if (deck.ui.stateLabel) deck.ui.stateLabel.textContent = 'Loading';
    deck.audio.src = track.previewUrl;
    deck.audio.load();
    deck.cue = 0;
    deck.loopSeconds = 0;
    deck.pitch = 0;
    if (deck.ui.title) deck.ui.title.textContent = track.title;
    if (deck.ui.artist) deck.ui.artist.textContent = track.artistName;
    if (deck.ui.extra) deck.ui.extra.textContent = track.genre + (track.bpm ? ' · ' + track.bpm + ' BPM' : '');
    if (deck.ui.art) {
      deck.ui.art.src = track.artworkUrl || '';
      deck.ui.art.alt = track.title + ' artwork';
      deck.ui.art.hidden = !track.artworkUrl;
    }
    if (deck.ui.fallback) deck.ui.fallback.hidden = !!track.artworkUrl;
    if (deck.ui.trackLink) { deck.ui.trackLink.href = track.productUrl; deck.ui.trackLink.hidden = false; }
    if (deck.ui.artistLink) { deck.ui.artistLink.href = track.artistUrl || '/pages/artists'; deck.ui.artistLink.hidden = false; }
    if (deck.ui.cart) deck.ui.cart.disabled = !track.variantId;
    if (deck.ui.cartLabel) deck.ui.cartLabel.textContent = track.variantId ? 'Add to Bag' : 'Preview';
    deck.host.dataset.trackId = track.id;
    deckMessage(deck, options.manual === true ? 'Staged for Auto Mix · this selection is protected.' : 'Loaded from Shopify CDN.');
    applyTone(deck);
    markActive(deck);
    renderQuickLoad();
    renderBrowser();
    renderPlaylist();
    deck.loadTimer = later(function () {
      deck.host.classList.remove('is-track-loading');
      deck.host.classList.add('is-track-loaded');
      if (deck.ui.stateLabel && deck.audio.paused) deck.ui.stateLabel.textContent = deck.autoMixArmedId === track.id ? 'Next' : 'Armed';
    }, 480);
    if (wasPlaying && !options.paused) togglePlay(deck);
    scheduleSave();
  }

  async function togglePlay(deck) {
    if (!deck.audio.paused) {
      deck.scratchResume = false;
      deck.audio.pause();
      return;
    }
    if (!deck.track) { loadTrack(deck, tracks[0], {manual:false}); }
    if (!watchPlayback(deck, function () { togglePlay(deck); })) return;
    deck.scratchResume = false;
    markActive(deck);
    try {
      claimAudioFocus(deck);
      ensureDeckAudible(deck);
      await ensureAudioGraph();
      assertActive();
      await deck.audio.play();
      assertActive();
      setAutoMixArm(deck, null);
      deckMessage(deck, 'Live signal');
      status('Radio paused · Deck ' + deck.key.toUpperCase() + ' live');
    } catch (_) { deckMessage(deck, 'Tap play again to start audio.'); }
  }

  function setCue(deck) {
    if (!deck.track) return;
    deck.cue = Number(deck.audio.currentTime || 0);
    deckMessage(deck, 'Cue set · ' + formatTime(deck.cue));
    flashControl(deck.ui.setCue);
    scheduleSave();
  }
  function jumpCue(deck) {
    if (!deck.track) return;
    deck.audio.currentTime = deck.cue || 0;
    deckMessage(deck, 'Cue · ' + formatTime(deck.audio.currentTime));
    flashControl(deck.ui.cue);
  }
  function syncDeck(deck) {
    var other = opposing(deck);
    if (!deck.track || !other.track || !deck.track.bpm || !other.track.bpm) { deckMessage(deck, 'Both decks need BPM data.'); return; }
    deck.pitch = clamp((other.track.bpm / deck.track.bpm - 1) * 100, -10, 10);
    if (deck.ui.pitch) deck.ui.pitch.value = String(deck.pitch);
    applyTone(deck);
    updateDeck(deck);
    deckMessage(deck, 'Synced to Deck ' + other.key.toUpperCase() + '.');
    flashControl(deck.ui.sync);
  }
  function setLoop(deck, seconds, button) {
    if (!deck.track) return;
    deck.loopSeconds = deck.loopSeconds === seconds ? 0 : seconds;
    deck.loopStart = Number(deck.audio.currentTime || 0);
    deck.host.querySelectorAll('[data-deck-loop]').forEach(function (node) {
      var armed = node === button && !!deck.loopSeconds;
      node.classList.toggle('is-active', armed);
      node.setAttribute('aria-pressed', String(armed));
    });
    deckMessage(deck, deck.loopSeconds ? deck.loopSeconds + ' second loop armed.' : 'Loop released.');
    scheduleSave();
  }

  async function addToCart(deck, trigger) {
    if (!deck.track || !deck.track.variantId) { deckMessage(deck, 'Preview only · store edition coming soon.'); return; }
    var label = deck.ui.cartLabel;
    var button = deck.ui.cart;
    var opener = trigger || button;
    if (button && button.getAttribute('aria-busy') === 'true') return;
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var sectionIds = cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function'
      ? cart.getSectionsToRender().map(function (section) { return section.id; })
      : [];
    var routeRoot = global.Shopify && global.Shopify.routes ? global.Shopify.routes.root : '/';
    var cartUrl = global.routes && global.routes.cart_url ? global.routes.cart_url : routeRoot + 'cart';
    var addUrl = global.routes && global.routes.cart_add_url ? global.routes.cart_add_url : routeRoot + 'cart/add.js';
    var payload = { items: [{ id: deck.track.variantId, quantity: 1 }] };
    if (sectionIds.length) {
      payload.sections = sectionIds;
      payload.sections_url = global.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(opener);
    }
    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.classList.remove('is-added', 'is-cart-error');
    }
    if (label) label.textContent = 'Adding…';
    try {
      var response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      });
      var data = await response.json();
      if (!response.ok || data.status) throw new Error('Cart request failed');
      if (label) label.textContent = 'Added ✓';
      if (button) button.classList.add('is-added');
      deckMessage(deck, 'Added to your bag.');
      var sectionsReady = sectionIds.length && data.sections && sectionIds.every(function (sectionId) {
        return typeof data.sections[sectionId] === 'string' && data.sections[sectionId].trim();
      });
      if (!sectionsReady) {
        global.location.assign(cartUrl);
        return;
      }
      try {
        var addedItem = data.items ? data.items[0] : data;
        if (opener && opener.isConnected === false && typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(document.getElementById('cart-icon-bubble'));
        }
        cart.renderContents(Object.assign({}, addedItem, { sections: data.sections }));
      } catch (error) {
        global.location.assign(cartUrl);
        return;
      }
      later(function () {
        if (label) label.textContent = 'Add to Bag';
        if (button) {
          button.classList.remove('is-added');
          button.removeAttribute('aria-busy');
        }
      }, 1800);
    } catch (_) {
      if (label) label.textContent = 'Try Again';
      if (button) {
        button.classList.add('is-cart-error');
        button.removeAttribute('aria-busy');
      }
      deckMessage(deck, 'Cart signal interrupted.');
    }
  }

  function bindDeck(deck) {
    listen(deck.host, 'pointerdown', function () { markActive(deck); });
    listen(deck.ui.play, 'click', function () { togglePlay(deck); });
    listen(deck.ui.setCue, 'click', function () { setCue(deck); });
    listen(deck.ui.cue, 'click', function () { jumpCue(deck); });
    listen(deck.ui.sync, 'click', function () { syncDeck(deck); });
    listen(deck.ui.eject, 'click', function () { openDrawer(deck.key); });
    listen(deck.ui.cart, 'pointerdown', function (event) { event.stopPropagation(); });
    listen(deck.ui.cart, 'click', function (event) { event.stopPropagation(); addToCart(deck, event.currentTarget); });
    listen(deck.ui.nudgeBack, 'click', function () { if (deck.track) deck.audio.currentTime = Math.max(0, deck.audio.currentTime - 0.06); });
    listen(deck.ui.nudgeForward, 'click', function () { if (deck.track) deck.audio.currentTime += 0.06; });
    deck.host.querySelectorAll('[data-deck-loop]').forEach(function (button) {
      listen(button, 'click', function () { setLoop(deck, Number(button.dataset.deckLoop), button); });
    });
    if (deck.ui.volume) listen(deck.ui.volume, 'input', function () { deck.volume = Number(this.value) / 100; applyMix(); updateDeck(deck); scheduleSave(); });
    listen(deck.ui.filter, 'input', function () { deck.filter = Number(this.value); applyTone(deck); updateDeck(deck); scheduleSave(); });
    listen(deck.ui.pitch, 'input', function () { deck.pitch = Number(this.value); applyTone(deck); updateDeck(deck); scheduleSave(); });
    if (deck.ui.keyLockBtn) listen(deck.ui.keyLockBtn, 'click', function () {
      deck.keyLock = !deck.keyLock;
      renderKeyLock(deck);
      applyTone(deck);
      scheduleSave();
    });
    listen(deck.ui.progress, 'input', function () { if (Number.isFinite(deck.audio.duration)) deck.audio.currentTime = Number(this.value) / 1000 * deck.audio.duration; });
    listen(deck.audio, 'timeupdate', function () {
      if (deck.loopSeconds && deck.audio.currentTime >= deck.loopStart + deck.loopSeconds) deck.audio.currentTime = deck.loopStart;
      updateDeck(deck);
      maybeAutoPlayAdvance(deck);
    });
    listen(deck.audio, 'play', function () { if (deck.track && deck.track.genreSlug) lastPlayedGenre = deck.track.genreSlug; claimAudioFocus(deck); updateDeck(deck); scheduleSave(); });
    listen(deck.audio, 'pause', function () { updateDeck(deck); scheduleSave(); });
    listen(deck.audio, 'ended', function () {
      updateDeck(deck);
      scheduleSave();
      // Auto Play safety net — a record that slipped past the 15-second cue
      // (shorter than the lead, scrubbed to the end, Auto Mix busy at the
      // moment) still hands over instead of leaving the room silent.
      if (autoPlay && !autoMixInProgress && decks.a.audio.paused && decks.b.audio.paused) runAutoMix();
    });
    listen(deck.ui.platter, 'pointerdown', function (event) {
      if (event.target.closest('[data-deck-action="cart"]')) return;
      if (!deck.track) return;
      deck.scratchResume = !deck.audio.paused;
      deck.audio.pause();
      deck.scratchX = event.clientX;
      deck.ui.platter.setPointerCapture(event.pointerId);
      deck.host.classList.add('is-scratching');
    });
    listen(deck.ui.platter, 'pointermove', function (event) {
      if (!deck.ui.platter.hasPointerCapture(event.pointerId) || !deck.track) return;
      var delta = event.clientX - deck.scratchX;
      deck.scratchX = event.clientX;
      deck.audio.currentTime = clamp(deck.audio.currentTime + delta * 0.025, 0, Number.isFinite(deck.audio.duration) ? deck.audio.duration : 9999);
      deck.angle += delta * 0.6;
      updateDeck(deck);
    });
    var platterRelease = function (event) {
      // Only a release of OUR capture ends a scratch — a bubbled pointerup
      // from the cart button must not toggle playback.
      if (!deck.ui.platter.hasPointerCapture(event.pointerId)) return;
      deck.ui.platter.releasePointerCapture(event.pointerId);
      deck.host.classList.remove('is-scratching');
      if (deck.scratchResume) togglePlay(deck);
    };
    listen(deck.ui.platter, 'pointerup', platterRelease);
    listen(deck.ui.platter, 'pointercancel', platterRelease);
    listen(deck.host, 'dragover', function (event) { event.preventDefault(); deck.host.classList.add('is-drop-target'); });
    listen(deck.host, 'dragleave', function () { deck.host.classList.remove('is-drop-target'); });
    listen(deck.host, 'drop', function (event) {
      event.preventDefault();
      deck.host.classList.remove('is-drop-target');
      var track = getTrack(event.dataTransfer.getData('text/x-fara-track'));
      if (track) loadTrack(deck, track, {manual:true});
    });
  }

  function shuffleTracks(items) {
    var shuffled = items.slice();
    for (var index = shuffled.length - 1; index > 0; index -= 1) {
      var swapIndex = Math.floor(Math.random() * (index + 1));
      var held = shuffled[index];
      shuffled[index] = shuffled[swapIndex];
      shuffled[swapIndex] = held;
    }
    return shuffled;
  }

  function quickLoadPool() {
    return tracks.filter(function (track) { return !quickLoadGenre || track.genreSlug === quickLoadGenre; });
  }

  function reseedQuickLoad() {
    var pool = quickLoadPool();
    quickLoadIds = shuffleTracks(pool).slice(0, 12).map(function (track) { return track.id; });
    renderQuickLoad();
  }

  function renderQuickLoad() {
    var dock = byId('dj-spine-track-dock');
    if (!dock) return;
    if (!quickLoadIds.length) quickLoadIds = shuffleTracks(quickLoadPool()).slice(0, 12).map(function (track) { return track.id; });
    var quickTracks = quickLoadIds.map(getTrack).filter(Boolean);
    var count = byId('dj-quickload-count');
    var genreControl = byId('dj-quickload-genre');
    var genreName = genreControl && genreControl.selectedOptions.length ? genreControl.selectedOptions[0].textContent : 'All genres';
    var poolSize = quickLoadPool().length;
    if (count) count.textContent = quickTracks.length + ' random / ' + poolSize + ' ' + (genreName === 'All genres' ? 'records' : genreName + ' records');
    dock.innerHTML = quickTracks.map(function (track, index) {
      var loaded = decks.a.track && decks.a.track.id === track.id || decks.b.track && decks.b.track.id === track.id;
      return '<button type="button" class="dj-spine-track' + (loaded ? ' is-loaded' : '') + '" draggable="true" data-track-id="' + escapeHtml(track.id) + '" aria-label="Load ' + escapeHtml(track.title) + '">' +
        '<span class="dj-spine-track-icon">' + (track.artworkUrl ? '<img src="' + escapeHtml(track.artworkUrl) + '" alt="' + escapeHtml(track.title) + ' artwork" loading="lazy">' : '<span>' + String(index + 1).padStart(2, '0') + '</span>') + '</span>' +
        '<span class="dj-spine-track-copy"><strong>' + escapeHtml(track.title) + '</strong><span>' + escapeHtml(track.artistName) + '</span></span></button>';
    }).join('');
  }

  function bindQuickLoad() {
    var dock = byId('dj-spine-track-dock');
    if (!dock) return;
    listen(dock, 'click', function (event) {
      var button = event.target.closest('[data-track-id]');
      if (button && dock.contains(button)) loadTrack(recommendedLoadDeck(), getTrack(button.dataset.trackId), {manual:true});
    });
    listen(dock, 'dragstart', function (event) {
      var button = event.target.closest('[data-track-id]');
      if (button && dock.contains(button)) event.dataTransfer.setData('text/x-fara-track', button.dataset.trackId);
    });
  }

  function filterOptions() {
    var genreControls = [byId('dj-browser-genre'), byId('dj-quickload-genre'), byId('dj-simple-genre')].filter(Boolean);
    var genreMap = {};
    tracks.forEach(function (track) {
      if (track.genreSlug && track.genre) genreMap[track.genreSlug] = track.genre;
    });
    Object.keys(genreMap).sort(function (a, b) { return genreMap[a].localeCompare(genreMap[b]); }).forEach(function (slug) {
      genreControls.forEach(function (genre) {
        genre.insertAdjacentHTML('beforeend', '<option value="' + escapeHtml(slug) + '">' + escapeHtml(genreMap[slug]) + '</option>');
      });
    });
    reseedQuickLoad();
  }

  function bpmMatches(track) {
    if (!filters.bpm) return true;
    var bpm = Number(track.bpm || 0);
    if (!bpm) return false;
    if (filters.bpm === 'under-90') return bpm < 90;
    if (filters.bpm === '90-109') return bpm >= 90 && bpm <= 109;
    if (filters.bpm === '110-124') return bpm >= 110 && bpm <= 124;
    if (filters.bpm === '125-139') return bpm >= 125 && bpm <= 139;
    return bpm >= 140;
  }
  function visibleTracks() {
    var query = filters.search.toLowerCase();
    return tracks.filter(function (track) {
      var haystack = [track.title, track.artistName, track.genre].concat(track.subgenres || []).join(' ').toLowerCase();
      return (!query || haystack.indexOf(query) > -1) && (!filters.genre || track.genreSlug === filters.genre) && bpmMatches(track);
    }).sort(function (a, b) {
      return a.artistName.localeCompare(b.artistName) || a.title.localeCompare(b.title);
    });
  }

  function browserTrackMarkup(track) {
    var queued = playlist.indexOf(track.id) > -1;
    return '<article class="dj-browser-track"><span class="dj-browser-track-art"><img src="' + escapeHtml(track.artworkUrl) + '" alt="' + escapeHtml(track.title) + ' artwork" loading="lazy"></span>' +
      '<span class="dj-browser-track-copy"><strong>' + escapeHtml(track.title) + '</strong><span>' + escapeHtml(track.artistName) + '</span></span>' +
      '<span class="dj-browser-track-description"><span>' + escapeHtml(track.genre) + '</span><span>' + (track.bpm ? track.bpm + ' BPM' : 'Tempo analysing') + '</span></span>' +
      '<span class="dj-browser-track-actions"><button class="dj-browser-action" data-action="a" data-id="' + track.id + '">Deck A</button>' +
      '<button class="dj-browser-action" data-action="b" data-id="' + track.id + '">Deck B</button>' +
      '<button class="dj-browser-action' + (queued ? ' is-queued' : '') + '" data-action="queue" data-id="' + track.id + '">' + (queued ? 'Queued' : 'Add to Playlist') + '</button></span></article>';
  }
  function renderBrowser() {
    var list = byId('dj-browser-list');
    var result = byId('dj-browser-results');
    var previous = byId('dj-browser-previous');
    var next = byId('dj-browser-next');
    var pageStatus = byId('dj-browser-page-status');
    if (!list || !result) return;
    var matches = visibleTracks();
    var totalPages = Math.max(1, Math.ceil(matches.length / BROWSER_PAGE_SIZE));
    browserPage = clamp(browserPage, 0, totalPages - 1);
    var start = browserPage * BROWSER_PAGE_SIZE;
    var visible = matches.slice(start, start + BROWSER_PAGE_SIZE);
    var end = start + visible.length;
    result.textContent = matches.length + (matches.length === 1 ? ' record' : ' records') + (visible.length ? ' · ' + (start + 1) + '–' + end : ' · no matches');
    list.innerHTML = visible.length ? visible.map(browserTrackMarkup).join('') : '<div class="dj-browser-empty"><strong>No record matches that signal.</strong><p>Clear the filters and try another search.</p></div>';
    if (pageStatus) pageStatus.textContent = String(browserPage + 1).padStart(2, '0') + ' / ' + String(totalPages).padStart(2, '0');
    if (previous) previous.disabled = browserPage === 0;
    if (next) {
      next.disabled = browserPage >= totalPages - 1 || !matches.length;
      next.textContent = end < matches.length ? 'Next ' + Math.min(BROWSER_PAGE_SIZE, matches.length - end) : 'End of Set';
    }
  }

  function renderPlaylist() {
    playlist = playlist.filter(function (id) { return !!getTrack(id); });
    writeJson(PLAYLIST_KEY, playlist);
    var list = byId('dj-playlist-list');
    var count = byId('dj-playlist-count');
    var clear = byId('dj-playlist-clear');
    if (count) count.textContent = String(playlist.length);
    if (clear) clear.disabled = !playlist.length;
    if (!list) return;
    list.innerHTML = playlist.length ? playlist.map(function (id, index) {
      var track = getTrack(id);
      return '<li class="dj-playlist-item"><span class="dj-playlist-position">' + String(index + 1).padStart(2, '0') + '</span><span class="dj-playlist-copy"><strong>' + escapeHtml(track.title) + '</strong><span>' + escapeHtml(track.artistName) + '</span></span>' +
        '<span class="dj-playlist-actions"><button class="dj-playlist-action" data-playlist="a" data-id="' + id + '">A</button><button class="dj-playlist-action" data-playlist="b" data-id="' + id + '">B</button><button class="dj-playlist-action" data-playlist="remove" data-id="' + id + '">×</button></span></li>';
    }).join('') : '<li class="dj-playlist-empty">No tracks queued yet.</li>';
  }

  function openDrawer(key) {
    drawerDeckKey = key;
    drawerReturnFocus = document.activeElement;
    var drawer = byId('dj-library-drawer');
    var backdrop = byId('dj-library-backdrop');
    drawer.hidden = false;
    backdrop.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    document.body.classList.add('dj-drawer-open');
    var title = byId('dj-library-drawer-title');
    if (title) title.textContent = 'Load Deck ' + key.toUpperCase();
    renderDrawer();
    later(function () { var search = byId('dj-library-search'); if (search) search.focus(); }, 40);
  }
  function closeDrawer() {
    drawerDeckKey = '';
    var drawer = byId('dj-library-drawer');
    var backdrop = byId('dj-library-backdrop');
    if (drawer.contains(document.activeElement) && typeof document.activeElement.blur === 'function') document.activeElement.blur();
    if (drawerReturnFocus && drawerReturnFocus.isConnected && typeof drawerReturnFocus.focus === 'function') drawerReturnFocus.focus({preventScroll:true});
    drawerReturnFocus = null;
    drawer.hidden = true;
    backdrop.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.body.classList.remove('dj-drawer-open');
  }
  function renderDrawer() {
    var list = byId('dj-library-list');
    var search = (byId('dj-library-search').value || '').toLowerCase();
    var matches = tracks.filter(function (track) { return !search || (track.title + ' ' + track.artistName + ' ' + track.genre).toLowerCase().indexOf(search) > -1; });
    byId('dj-library-results').textContent = matches.length + ' records';
    list.innerHTML = matches.map(function (track) {
      return '<button type="button" class="dj-library-row" data-drawer-id="' + track.id + '"><span class="dj-library-row-art"><img src="' + escapeHtml(track.artworkUrl) + '" alt="' + escapeHtml(track.title) + ' artwork" loading="lazy"></span><span class="dj-library-row-copy"><strong class="dj-library-row-title">' + escapeHtml(track.title) + '</strong><span class="dj-library-row-meta">' + escapeHtml(track.artistName) + ' · ' + escapeHtml(track.genre) + '</span></span><span class="dj-library-row-load">Load</span></button>';
    }).join('');
  }

  function setAutoMixBusy(isBusy) {
    autoMixInProgress = !!isBusy;
    var button = byId('dj-auto-mix-button');
    if (!button) return;
    button.disabled = autoMixInProgress;
    if (autoMixInProgress) button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
  }

  function cancelAutoMix() {
    clearInterval(autoMixTimer);
    autoMixTimer = 0;
    setAutoMixBusy(false);
  }

  function isValidAutoMixArm(deck) {
    return !!(deck.track && deck.audio.paused && deck.autoMixArmedId === deck.track.id);
  }

  function maybeAutoPlayAdvance(deck) {
    if (!autoPlay || autoMixInProgress) return;
    if (!deck.track || deck.audio.paused) return;
    if (deck.loopSeconds) return; // a held loop is a performance choice — never auto-advance out of it
    var duration = deck.audio.duration;
    if (!Number.isFinite(duration) || duration <= 0) return;
    var remaining = duration - deck.audio.currentTime;
    if (remaining > AUTO_PLAY_LEAD_SECONDS) {
      // Scrubbed back out of the window — re-arm for this record.
      if (deck.autoPlayFiredId === deck.track.id) deck.autoPlayFiredId = '';
      return;
    }
    if (liveAutoMixSource() !== deck) return; // only the audible deck cues the next record
    if (deck.autoPlayFiredId === deck.track.id) return;
    deck.autoPlayFiredId = deck.track.id;
    status('Auto Play · cueing the next record');
    runAutoMix();
  }

  // Ten seconds after a handover the freed deck stages the upcoming record —
  // loaded paused and armed, so the booth can see what's next ("Next" chip)
  // instead of the deck sitting stale until the 15-second cue fires.
  function preloadNextTrack(deck) {
    if (!autoPlay || autoMixInProgress) return;
    if (!deck.audio.paused) return;
    if (isValidAutoMixArm(deck)) return;
    var live = liveAutoMixSource();
    if (!live || live === deck) return;
    var candidate = resolveAutoMixCandidate(live, deck);
    if (!candidate || !candidate.track || candidate.origin === 'manual') return;
    loadTrack(deck, candidate.track, {paused: true, manual: false});
    setAutoMixArm(deck, candidate.track);
    consumeAutoMixCandidate(deck, candidate);
    deckMessage(deck, 'Next up · ' + candidate.origin + ' selection');
    markActive(live); // staging must not steal the booth highlight from the audible deck
  }

  function scheduleAutoPlayPreload(deck) {
    cancelLater(autoPlayPreloadTimer);
    if (!autoPlay || !deck) return;
    var trackIdAtSchedule = deck.track ? deck.track.id : '';
    autoPlayPreloadTimer = later(function () {
      autoPlayPreloadTimer = 0;
      // The user reached for this deck in the meantime — leave their choice alone.
      var trackIdNow = deck.track ? deck.track.id : '';
      if (trackIdNow !== trackIdAtSchedule) return;
      preloadNextTrack(deck);
    }, AUTO_PLAY_PRELOAD_DELAY_MS);
  }

  function liveAutoMixSource() {
    var aLive = !decks.a.audio.paused;
    var bLive = !decks.b.audio.paused;
    if (aLive && !bLive) return decks.a;
    if (bLive && !aLive) return decks.b;
    if (!aLive && !bLive) return null;
    if (crossfader < 47) return decks.a;
    if (crossfader > 53) return decks.b;
    return decks[activeDeckKey];
  }

  function randomCatalogueTrack(excludedIds, genreSlug) {
    var excluded = excludedIds.filter(Boolean);
    var pool = tracks.filter(function (track) { return excluded.indexOf(track.id) === -1; });
    if (genreSlug) {
      var genrePool = pool.filter(function (track) { return track.genreSlug === genreSlug; });
      if (genrePool.length) pool = genrePool;
    }
    if (!pool.length) pool = tracks.filter(function (track) { return !excludedIds[0] || track.id !== excludedIds[0]; });
    if (!pool.length) pool = tracks.slice();
    return pool[Math.floor(Math.random() * pool.length)] || null;
  }

  function resolveAutoMixCandidate(source, target) {
    if (isValidAutoMixArm(target)) return {track:target.track, origin:'manual', playlistIndex:-1};
    var sourceId = source && source.track ? source.track.id : '';
    var playlistIndex = playlist.findIndex(function (id) { return id !== sourceId && !!getTrack(id); });
    if (playlistIndex > -1) return {track:getTrack(playlist[playlistIndex]), origin:'playlist', playlistIndex:playlistIndex};
    // "Same genre as the last track": the live source's record if one is
    // playing, else the record that most recently played (from-rest restart),
    // else whatever was last loaded. An idle deck's stale record must never
    // outrank the record that actually left the floor.
    var lastGenre = source && source.track && !source.audio.paused ? source.track.genreSlug
      : lastPlayedGenre
        || (source && source.track ? source.track.genreSlug : '')
        || (target && target.track ? target.track.genreSlug : '');
    return {
      track: randomCatalogueTrack([sourceId, target && target.track ? target.track.id : ''], lastGenre),
      origin: 'random',
      playlistIndex: -1
    };
  }

  function consumeAutoMixCandidate(target, candidate) {
    if (candidate.origin === 'manual') setAutoMixArm(target, null);
    if (candidate.origin === 'playlist') {
      var queuedIndex = playlist.indexOf(candidate.track.id);
      if (queuedIndex > -1) playlist.splice(queuedIndex, 1);
    }
    renderPlaylist();
    renderBrowser();
  }

  function prepareAutoMixTarget(target, candidate) {
    if (!candidate || !candidate.track) return false;
    if (candidate.origin === 'manual') {
      target.scratchResume = false;
      try { target.audio.currentTime = Math.max(0, Number(target.cue || 0)); } catch (_) {}
      return true;
    }
    loadTrack(target, candidate.track, {paused:true, manual:false});
    return true;
  }

  function startAutoMixFromRest() {
    var staged = [decks.a, decks.b].filter(isValidAutoMixArm);
    var target = staged.indexOf(decks[activeDeckKey]) > -1 ? decks[activeDeckKey] : staged[0] || decks[activeDeckKey];
    var source = opposing(target);
    var candidate = isValidAutoMixArm(target)
      ? {track:target.track, origin:'manual', playlistIndex:-1}
      : resolveAutoMixCandidate(source, target);
    if (!prepareAutoMixTarget(target, candidate)) {
      setAutoMixBusy(false);
      status('Auto Mix waiting · no playable record');
      return;
    }
    if (!watchPlayback(target, function () { togglePlay(target); })) { setAutoMixBusy(false); return; }
    claimAudioFocus(target);
    Promise.resolve(ensureAudioGraph()).then(function () { assertActive(); return target.audio.play(); }).then(function () {
      assertActive();
      consumeAutoMixCandidate(target, candidate);
      setCrossfader(target.key === 'a' ? 0 : 100);
      markActive(target);
      setAutoMixBusy(false);
      deckMessage(target, 'Live signal · ' + (candidate.origin === 'manual' ? 'staged selection' : candidate.origin + ' selection'));
      status('Auto Mix started · Deck ' + target.key.toUpperCase() + ' live');
      if (autoPlay) scheduleAutoPlayPreload(opposing(target));
    }).catch(function () {
      setAutoMixBusy(false);
      deckMessage(target, 'Tap play to continue Auto Mix.');
    });
  }

  function runAutoMix() {
    if (autoMixInProgress) return;
    if (disposed || !root.isConnected) return;
    cancelAutoMix();
    setAutoMixBusy(true);
    var source = liveAutoMixSource();
    if (!source) {
      startAutoMixFromRest();
      return;
    }
    var target = opposing(source);
    var candidate = resolveAutoMixCandidate(source, target);
    if (!prepareAutoMixTarget(target, candidate)) {
      setAutoMixBusy(false);
      status('Auto Mix waiting · no playable record');
      return;
    }
    if (!watchPlayback(target, function () { togglePlay(target); })) { setAutoMixBusy(false); return; }
    claimAudioFocus(target);
    Promise.resolve(ensureAudioGraph()).then(function () { assertActive(); return target.audio.play(); }).then(function () {
      assertActive();
      consumeAutoMixCandidate(target, candidate);
      deckMessage(target, 'Auto Mix live · ' + (candidate.origin === 'manual' ? 'staged selection' : candidate.origin + ' selection'));
      var start = performance.now();
      var from = crossfader;
      var to = target.key === 'a' ? 0 : 100;
      // Interval, not requestAnimationFrame: rAF suspends in hidden tabs,
      // which left Auto Play's handover frozen mid-fade (new deck at zero
      // gain, busy flag stuck) whenever the listener tabbed away. Progress
      // is computed from elapsed time, so even a background tab's throttled
      // 1s ticks land the fade; an audio-playing tab is exempt from
      // intensive throttling.
      function step() {
        var progress = clamp((performance.now() - start) / 6500, 0, 1);
        var eased = progress * progress * (3 - 2 * progress);
        setCrossfader(from + (to - from) * eased, {persist:false, snapToCentre:false});
        if (progress >= 1) {
          clearInterval(autoMixTimer);
          autoMixTimer = 0;
          source.audio.pause();
          markActive(target);
          setAutoMixBusy(false);
          deckMessage(target, 'Live signal · Auto Mix complete.');
          scheduleSave();
          status('Auto Mix complete · Deck ' + target.key.toUpperCase() + ' live');
          if (autoPlay) scheduleAutoPlayPreload(source);
        }
      }
      autoMixTimer = setInterval(step, 50);
    }).catch(function () {
      setAutoMixBusy(false);
      deckMessage(target, 'Tap play to continue Auto Mix.');
    });
  }

  var saveTimer = 0;
  function saveSession() {
    writeJson(STORAGE_KEY, {
      mixerVersion: MIXER_STATE_VERSION,
      activeDeck: activeDeckKey,
      crossfader: crossfader,
      decks: { a: snapshotDeck(decks.a), b: snapshotDeck(decks.b) }
    });
  }
  function scheduleSave() {
    cancelLater(saveTimer);
    saveTimer = later(saveSession, 350);
  }
  function snapshotDeck(deck) {
    return deck.track ? {id:deck.track.id,time:deck.audio.currentTime,volume:deck.volume,pitch:deck.pitch,filter:deck.filter,keyLock:deck.keyLock !== false,cue:deck.cue,autoMixArmedId:deck.autoMixArmedId || ''} : null;
  }
  function restoreSession() {
    var saved = readJson(STORAGE_KEY, null);
    if (!saved) return false;
    ['a','b'].forEach(function (key) {
      var snap = saved.decks && saved.decks[key];
      var track = snap && getTrack(snap.id);
      if (!track) return;
      var deck = decks[key];
      loadTrack(deck, track, {paused:true});
      var savedVolume = Number(snap.volume);
      deck.volume = clamp(Number.isFinite(savedVolume) ? savedVolume : 0.84, 0, 1);
      deck.pitch = clamp(Number(snap.pitch || 0), -10, 10);
      deck.filter = clamp(Number(snap.filter || 0), -100, 100);
      deck.keyLock = snap.keyLock !== false;
      deck.cue = Math.max(0, Number(snap.cue || 0));
      listen(deck.audio, 'loadedmetadata', function () { deck.audio.currentTime = clamp(Number(snap.time || 0), 0, deck.audio.duration || 0); }, {once:true});
      if (deck.ui.volume) deck.ui.volume.value = String(Math.round(deck.volume * 100));
      deck.ui.pitch.value = String(deck.pitch);
      deck.ui.filter.value = String(deck.filter);
      renderKeyLock(deck);
      applyTone(deck);
      if (snap.autoMixArmedId === track.id) setAutoMixArm(deck, track);
    });
    var savedCrossfader = Number(saved.crossfader);
    crossfader = saved.mixerVersion === MIXER_STATE_VERSION && Number.isFinite(savedCrossfader) ? clamp(savedCrossfader, 0, 100) : 50;
    byId('dj-crossfader').value = String(crossfader);
    activeDeckKey = saved.activeDeck === 'b' ? 'b' : 'a';
    applyMix();
    markActive(decks[activeDeckKey]);
    status('Previous session restored · decks paused');
    return true;
  }

  function drawWave(deck) {
    var canvas = deck.ui.wave;
    if (!canvas) return;
    var ratio = global.devicePixelRatio || 1;
    var width = Math.max(1, Math.floor(canvas.clientWidth * ratio));
    var height = Math.max(1, Math.floor(canvas.clientHeight * ratio));
    if (canvas.width !== width || canvas.height !== height) { canvas.width = width; canvas.height = height; }
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0,0,width,height);
    var bars = 64;
    if (deck.analyser && deck.frequencyData && !deck.audio.paused) deck.analyser.getByteFrequencyData(deck.frequencyData);
    var levelTotal = 0;
    for (var i=0;i<bars;i+=1) {
      var live = deck.frequencyData && !deck.audio.paused ? deck.frequencyData[Math.floor(i / bars * deck.frequencyData.length)] / 255 : 0.12 + Math.abs(Math.sin(i * 0.73 + (deck.track ? deck.track.rank : 1))) * 0.18;
      levelTotal += live;
      var barHeight = Math.max(1, live * height * 0.78);
      ctx.fillStyle = deck.key === 'a' ? 'rgba(83,200,255,' + (0.24 + live * 0.76) + ')' : 'rgba(131,231,123,' + (0.24 + live * 0.76) + ')';
      ctx.fillRect(i / bars * width, (height - barHeight) / 2, Math.max(1, width / bars - ratio), barHeight);
    }
    var level = deck.audio.paused ? 0.08 : clamp(levelTotal / bars * 1.55, 0.12, 1);
    deck.liveLevel = level;
    deck.host.style.setProperty('--deck-level', level.toFixed(3));
    deck.host.style.setProperty('--deck-energy', (0.12 + level * 0.52).toFixed(3));
    deck.host.style.setProperty('--deck-meter', (level * 100).toFixed(1) + '%');
  }
  var masterSignalNode = byId('dj-master-signal');
  var masterPips = masterSignalNode ? Array.prototype.slice.call(masterSignalNode.children) : [];

  function updateMasterSignal() {
    if (!masterPips.length) return;
    // The analyser sits before the gain node, so fold in each deck's channel
    // volume and crossfade share to show what actually reaches the master bus.
    var x = clamp(crossfader / 100, 0, 1);
    var levelA = (decks.a.audio.paused ? 0 : decks.a.liveLevel) * decks.a.volume * Math.cos(x * Math.PI / 2);
    var levelB = (decks.b.audio.paused ? 0 : decks.b.liveLevel) * decks.b.volume * Math.sin(x * Math.PI / 2);
    var lit = Math.round(clamp(Math.max(levelA, levelB) * 1.3, 0, 1) * masterPips.length);
    masterPips.forEach(function (pip, index) { pip.classList.toggle('is-lit', index < lit); });
  }

  function visualLoop() {
    Object.keys(decks).forEach(function (key) {
      var deck = decks[key];
      if (!deck.audio.paused) deck.angle += 0.36 * deck.audio.playbackRate;
      updateDeck(deck);
      drawWave(deck);
    });
    updateMasterSignal();
    if (loopRunning) rafId = requestAnimationFrame(visualLoop);
  }

  // The waveform/platter loop used to run requestAnimationFrame forever from
  // page load, unconditionally — every frame for as long as the tab stayed
  // open, even with both decks idle and the console scrolled off/backgrounded.
  // Gate it the same way the home-page hero/cinema sections already do:
  // IntersectionObserver stops it when the console isn't on screen, and
  // visibilitychange stops it when the tab itself is hidden.
  function startVisualLoop() {
    if (disposed || loopRunning || !root.isConnected) return;
    loopRunning = true;
    rafId = requestAnimationFrame(visualLoop);
  }
  function stopVisualLoop() {
    loopRunning = false;
    if (rafId) cancelAnimationFrame(rafId);
    rafId = 0;
  }

  function bindGlobal() {
    var crossfaderControl = byId('dj-crossfader');
    listen(crossfaderControl, 'input', function () {
      cancelAutoMix();
      setCrossfader(this.value, {snapToCentre:false});
    });
    listen(crossfaderControl, 'pointerup', function () {
      if (Math.abs(Number(this.value) - 50) <= 3) setCrossfader(50);
    });
    listen(crossfaderControl, 'dblclick', function () {
      cancelAutoMix();
      setCrossfader(50);
    });
    listen(crossfaderControl, 'keydown', function (event) {
      if (event.key.toLowerCase() !== 'c') return;
      event.preventDefault();
      cancelAutoMix();
      setCrossfader(50);
    });
    listen(byId('dj-crossfader-center'), 'click', function () {
      cancelAutoMix();
      setCrossfader(50);
      crossfaderControl.focus();
    });
    listen(byId('dj-auto-mix-button'), 'click', runAutoMix);
    ['a', 'b'].forEach(function (key) {
      var fader = byId('dj-channel-fader-' + key);
      if (!fader) return;
      listen(fader, 'input', function () {
        decks[key].volume = clamp(Number(this.value) / 100, 0, 1);
        applyMix();
        scheduleSave();
      });
    });
    var autoPlayButton = byId('dj-auto-play-button');
    if (autoPlayButton) listen(autoPlayButton, 'click', function () {
      autoPlay = !autoPlay;
      writeSetting(AUTO_PLAY_KEY, String(autoPlay));
      renderAutoPlay();
      if (autoPlay) {
        // Something already spinning? Stage the idle deck right away.
        var live = liveAutoMixSource();
        if (live) scheduleAutoPlayPreload(opposing(live));
      } else {
        cancelLater(autoPlayPreloadTimer);
        autoPlayPreloadTimer = 0;
      }
      status(autoPlay ? 'Auto Play on · cues a same-genre record 15s before the end' : 'Auto Play off · manual control');
    });
    listen(byId('dj-quickload-genre'), 'change', function () {
      quickLoadGenre = this.value;
      reseedQuickLoad();
    });
    listen(byId('dj-quickload-shuffle'), 'click', reseedQuickLoad);
    bindQuickLoad();
    listen(byId('dj-browser'), 'click', function (event) {
      var button = event.target.closest('[data-action]');
      if (!button) return;
      var track = getTrack(button.dataset.id);
      if (button.dataset.action === 'queue') {
        if (playlist.indexOf(track.id) === -1) playlist.push(track.id);
        else playlist = playlist.filter(function (id) { return id !== track.id; });
        renderPlaylist(); renderBrowser();
      } else loadTrack(decks[button.dataset.action], track, {manual:true});
    });
    listen(byId('dj-playlist-list'), 'click', function (event) {
      var button = event.target.closest('[data-playlist]');
      if (!button) return;
      if (button.dataset.playlist === 'remove') playlist = playlist.filter(function (id) { return id !== button.dataset.id; });
      else loadTrack(decks[button.dataset.playlist], getTrack(button.dataset.id), {manual:true});
      renderPlaylist(); renderBrowser();
    });
    listen(byId('dj-playlist-clear'), 'click', function () { playlist = []; renderPlaylist(); renderBrowser(); });
    [['dj-browser-search','search'],['dj-browser-genre','genre'],['dj-browser-bpm','bpm']].forEach(function (pair) {
      listen(byId(pair[0]), pair[1] === 'search' ? 'input' : 'change', function () { filters[pair[1]] = this.value.trim().toLowerCase(); browserPage = 0; renderBrowser(); });
    });
    listen(byId('dj-browser-clear'), 'click', function () {
      filters = {search:'',genre:'',bpm:''};
      browserPage = 0;
      ['dj-browser-search','dj-browser-genre','dj-browser-bpm'].forEach(function (id) { byId(id).value = ''; });
      renderBrowser();
    });
    listen(byId('dj-browser-previous'), 'click', function () { browserPage = Math.max(0, browserPage - 1); renderBrowser(); });
    listen(byId('dj-browser-next'), 'click', function () { browserPage += 1; renderBrowser(); });
    root.querySelectorAll('[data-mobile-deck]').forEach(function (button) {
      listen(button, 'click', function () { markActive(decks[button.dataset.mobileDeck]); });
    });
    listen(byId('dj-library-close'), 'click', closeDrawer);
    listen(byId('dj-library-backdrop'), 'click', closeDrawer);
    listen(byId('dj-library-search'), 'input', renderDrawer);
    listen(byId('dj-library-list'), 'click', function (event) {
      var row = event.target.closest('[data-drawer-id]');
      if (!row) return;
      loadTrack(decks[drawerDeckKey || activeDeckKey], getTrack(row.dataset.drawerId), {manual:true});
      closeDrawer();
    });
    listen(byId('dj-keep-playing'), 'click', function () {
      keepPlaying = !keepPlaying;
      writeSetting(KEEP_PLAYING_KEY, String(keepPlaying));
      updateKeepPlaying();
    });
    listen(byId('dj-exit-button'), 'click', function () {
      decks.a.audio.pause(); decks.b.audio.pause(); saveSession(); global.location.assign(global.Shopify && global.Shopify.routes ? global.Shopify.routes.root : '/');
    });
    listen(root, 'click', function (event) {
      var link = event.target.closest('a[href]');
      if (link && keepPlaying && (!decks.a.audio.paused || !decks.b.audio.paused)) link.target = 'fara-dj-browse';
    });
    listen(document, 'keydown', function (event) {
      if (event.key.toLowerCase() === 'f' && !/input|select|textarea/i.test(event.target.tagName)) {
        event.preventDefault();
        if (!document.fullscreenElement) root.requestFullscreen && root.requestFullscreen();
        else document.exitFullscreen && document.exitFullscreen();
      }
      if (event.key === 'Escape' && drawerDeckKey) closeDrawer();
    });
    listen(document, 'fullscreenchange', function () { document.body.classList.toggle('dj-performance-mode', !!document.fullscreenElement); });
    listen(global, 'pagehide', saveSession);
    listen(global, 'sx:audio-play', function (event) {
      if (event.detail && event.detail.source === 'dj-deck') return;
      var pausedDeck = false;
      Object.keys(decks).forEach(function (key) {
        if (!decks[key].audio.paused) {
          decks[key].audio.pause();
          pausedDeck = true;
        }
      });
      if (pausedDeck) status('External player live · decks paused');
    });
  }

  function updateKeepPlaying() {
    var button = byId('dj-keep-playing');
    var label = byId('dj-keep-playing-label');
    button.classList.toggle('is-off', !keepPlaying);
    button.setAttribute('aria-pressed', String(keepPlaying));
    label.textContent = 'Keep Playing · ' + (keepPlaying ? 'On' : 'Off');
  }

  function renderAutoPlay() {
    var button = byId('dj-auto-play-button');
    if (!button) return;
    button.classList.toggle('is-on', autoPlay);
    button.setAttribute('aria-pressed', String(autoPlay));
  }

  // ---- Pocket Deck: the phone-first lens on the same engine ----
  // Phones default to this one-player view (the pro console reads as
  // cockpit overload on a small screen); the preference only applies on
  // mobile widths, so desktop always gets the full rig.
  function simpleModeWanted() {
    if (!byId('dj-simple')) return false;
    if (!(mobileQuery && mobileQuery.matches)) return false;
    return simplePreference !== 'off';
  }

  function simpleDeck() {
    return liveAutoMixSource() || decks[activeDeckKey];
  }

  function applyViewMode() {
    simpleActive = simpleModeWanted();
    var simpleNode = byId('dj-simple');
    if (simpleNode) simpleNode.hidden = !simpleActive;
    document.body.classList.toggle('dj-simple-mode', simpleActive);
    if (simpleActive) {
      // A drawer left open on the pro console would keep its body
      // scroll-lock while being display:none'd — close it properly.
      closeDrawer();
      renderSimpleList();
      renderSimpleNow(true);
    }
  }

  var simpleShownTrackId = '';
  function renderSimpleNow(force) {
    if (!simpleActive) return;
    var deck = simpleDeck();
    var track = deck.track;
    var playing = !deck.audio.paused;
    var stateNode = byId('dj-simple-state');
    if (stateNode) stateNode.textContent = playing ? 'On Air' : track ? 'Paused' : 'Ready';
    if (stateNode) stateNode.classList.toggle('is-live', playing);
    var playButton = byId('dj-simple-play');
    if (playButton) {
      playButton.textContent = playing ? 'Pause' : 'Play';
      playButton.setAttribute('aria-pressed', String(playing));
    }
    var autoButton = byId('dj-simple-auto');
    if (autoButton) {
      autoButton.classList.toggle('is-on', autoPlay);
      autoButton.setAttribute('aria-pressed', String(autoPlay));
      autoButton.textContent = 'Auto Play' + (autoPlay ? ' · On' : '');
    }
    var duration = Number.isFinite(deck.audio.duration) ? deck.audio.duration : 0;
    var bar = byId('dj-simple-bar');
    if (bar) bar.style.width = (duration ? clamp(deck.audio.currentTime / duration, 0, 1) * 100 : 0).toFixed(1) + '%';
    var meta = byId('dj-simple-meta');
    if (meta) meta.textContent = track
      ? track.genre + (track.bpm ? ' · ' + track.bpm + ' BPM' : '') + ' · ' + formatTime(deck.audio.currentTime) + ' / ' + formatTime(duration)
      : 'Tap any track below';
    var other = opposing(deck);
    var nextUp = byId('dj-simple-next-up');
    if (nextUp) {
      var staged = other.track && other.audio.paused && other.autoMixArmedId === other.track.id ? other.track : null;
      nextUp.hidden = !staged;
      if (staged) nextUp.textContent = 'Next up · ' + staged.title + ' — ' + staged.artistName;
    }
    if (force || simpleShownTrackId !== (track ? track.id : '')) {
      simpleShownTrackId = track ? track.id : '';
      var art = byId('dj-simple-art');
      var fallback = byId('dj-simple-art-fallback');
      if (art) {
        art.src = track && track.artworkUrl ? track.artworkUrl : '';
        art.hidden = !(track && track.artworkUrl);
      }
      if (fallback) fallback.hidden = !!(track && track.artworkUrl);
      var title = byId('dj-simple-title');
      if (title) title.textContent = track ? track.title : 'Pick a record';
      var artist = byId('dj-simple-artist');
      if (artist) artist.textContent = track ? track.artistName : 'FARA Records';
      var bag = byId('dj-simple-bag');
      if (bag) bag.disabled = !(track && track.variantId);
      var link = byId('dj-simple-track-link');
      if (link) {
        link.hidden = !track;
        if (track) link.href = track.productUrl;
      }
      var list = byId('dj-simple-list');
      if (list) {
        var rows = list.querySelectorAll('[data-simple-id]');
        for (var i = 0; i < rows.length; i += 1) rows[i].classList.toggle('is-live', rows[i].dataset.simpleId === simpleShownTrackId);
      }
    }
  }

  function simpleFilteredTracks() {
    var genreSelect = byId('dj-simple-genre');
    var searchInput = byId('dj-simple-search');
    var genre = genreSelect ? genreSelect.value : '';
    var query = searchInput ? searchInput.value.trim().toLowerCase() : '';
    return tracks.filter(function (track) {
      var haystack = [track.title, track.artistName, track.genre].concat(track.subgenres || []).join(' ').toLowerCase();
      return (!genre || track.genreSlug === genre) && (!query || haystack.indexOf(query) > -1);
    });
  }

  function orderSimpleTracks(pool) {
    if (!simpleOrderIds.length) return pool;
    var available = {};
    var added = {};
    var ordered = [];
    pool.forEach(function (track) { available[track.id] = track; });
    simpleOrderIds.forEach(function (id) {
      if (!available[id]) return;
      ordered.push(available[id]);
      added[id] = true;
    });
    pool.forEach(function (track) { if (!added[track.id]) ordered.push(track); });
    return ordered;
  }

  function resetSimpleList(shuffle) {
    simpleVisibleLimit = SIMPLE_PAGE_SIZE;
    var pool = simpleFilteredTracks();
    simpleOrderIds = shuffle ? shuffleTracks(pool).map(function (track) { return track.id; }) : [];
    renderSimpleList();
  }

  function renderSimpleList() {
    var list = byId('dj-simple-list');
    if (!list) return;
    var pool = orderSimpleTracks(simpleFilteredTracks());
    var visible = pool.slice(0, simpleVisibleLimit);
    list.innerHTML = visible.map(function (track) {
      return '<button type="button" class="dj-simple-row" data-simple-id="' + escapeHtml(track.id) + '">'
        + '<span class="dj-simple-row-art"><img src="' + escapeHtml(track.artworkUrl) + '" width="92" height="92" alt="" loading="lazy"></span>'
        + '<span class="dj-simple-row-copy"><strong>' + escapeHtml(track.title) + '</strong><span>' + escapeHtml(track.artistName) + ' · ' + escapeHtml(track.genre) + '</span></span>'
        + '<span class="dj-simple-row-go" aria-hidden="true">▶</span>'
        + '</button>';
    }).join('');
    var count = byId('dj-simple-count');
    if (count) count.textContent = pool.length ? visible.length + ' / ' + pool.length + ' records' : 'No matches';
    var empty = byId('dj-simple-empty');
    if (empty) empty.hidden = pool.length > 0;
    var more = byId('dj-simple-more');
    if (more) {
      var remaining = Math.max(0, pool.length - visible.length);
      var batch = Math.min(SIMPLE_PAGE_SIZE, remaining);
      more.hidden = remaining === 0;
      more.setAttribute('aria-label', remaining ? 'Load ' + batch + ' more records, ' + remaining + ' remaining' : 'All matching records loaded');
      var moreLabel = more.querySelector('strong');
      if (moreLabel) moreLabel.textContent = remaining ? 'Load ' + batch + ' more' : 'All records loaded';
      var moreCopy = byId('dj-simple-more-copy');
      if (moreCopy) moreCopy.textContent = remaining ? remaining + ' remain' : '';
    }
    renderSimpleNow(true);
  }

  function simplePlayTrack(track) {
    if (!track) return;
    if (disposed || !root.isConnected) return;
    var live = liveAutoMixSource();
    var deck = live ? opposing(live) : decks[activeDeckKey];
    cancelAutoMix();
    loadTrack(deck, track, {paused: true, manual: false});
    if (live) live.audio.pause();
    setCrossfader(deck.key === 'a' ? 0 : 100);
    togglePlay(deck);
  }

  function bindSimple() {
    if (!byId('dj-simple')) return;
    var playButton = byId('dj-simple-play');
    if (playButton) listen(playButton, 'click', function () {
      // One button = one meaning. If ANYTHING is sounding (including both
      // decks mid-crossfade), Pause silences everything; otherwise play.
      if (!decks.a.audio.paused || !decks.b.audio.paused) {
        cancelAutoMix();
        decks.a.audio.pause();
        decks.b.audio.pause();
      } else {
        togglePlay(simpleDeck());
      }
    });
    var nextButton = byId('dj-simple-next');
    if (nextButton) listen(nextButton, 'click', runAutoMix);
    var autoButton = byId('dj-simple-auto');
    if (autoButton) listen(autoButton, 'click', function () {
      var proButton = byId('dj-auto-play-button');
      if (proButton) proButton.click();
      else {
        autoPlay = !autoPlay;
        writeSetting(AUTO_PLAY_KEY, String(autoPlay));
      }
      renderSimpleNow(true);
    });
    var bagButton = byId('dj-simple-bag');
    if (bagButton) listen(bagButton, 'click', function (event) { addToCart(simpleDeck(), event.currentTarget); });
    var genreSelect = byId('dj-simple-genre');
    if (genreSelect) listen(genreSelect, 'change', function () { resetSimpleList(false); });
    var searchInput = byId('dj-simple-search');
    if (searchInput) listen(searchInput, 'input', function () { resetSimpleList(false); });
    var shuffleButton = byId('dj-simple-shuffle');
    if (shuffleButton) listen(shuffleButton, 'click', function () { resetSimpleList(true); });
    var moreButton = byId('dj-simple-more');
    if (moreButton) listen(moreButton, 'click', function () {
      simpleVisibleLimit += SIMPLE_PAGE_SIZE;
      renderSimpleList();
    });
    var list = byId('dj-simple-list');
    if (list) listen(list, 'click', function (event) {
      var row = event.target.closest('[data-simple-id]');
      if (row) simplePlayTrack(getTrack(row.dataset.simpleId));
    });
    var proSwap = byId('dj-simple-pro');
    if (proSwap) listen(proSwap, 'click', function () {
      simplePreference = 'off';
      writeSetting(SIMPLE_KEY, 'off');
      applyViewMode();
    });
    var pocketButton = byId('dj-pocket-button');
    if (pocketButton) listen(pocketButton, 'click', function () {
      simplePreference = 'on';
      writeSetting(SIMPLE_KEY, 'on');
      applyViewMode();
    });
    if (mobileQuery) {
      if (typeof mobileQuery.addEventListener === 'function') listen(mobileQuery, 'change', applyViewMode);
      else if (typeof mobileQuery.addListener === 'function') {
        mobileQuery.addListener(applyViewMode);
        removers.push(function () { mobileQuery.removeListener(applyViewMode); });
      }
    }
  }

  function renderKeyLock(deck) {
    if (!deck.ui.keyLockBtn) return;
    deck.ui.keyLockBtn.classList.toggle('is-on', deck.keyLock !== false);
    deck.ui.keyLockBtn.setAttribute('aria-pressed', String(deck.keyLock !== false));
    deck.ui.keyLockBtn.textContent = 'Key Lock · ' + (deck.keyLock !== false ? 'On' : 'Off');
  }

  Object.keys(decks).forEach(function (key) { bindDeck(decks[key]); });
  filterOptions();
  bindGlobal();
  renderQuickLoad();
  renderBrowser();
  renderPlaylist();
  updateKeepPlaying();
  renderAutoPlay();
  bindSimple();
  applyViewMode();
  if (!restoreSession()) {
    loadTrack(decks.a, tracks[0], {paused:true});
    loadTrack(decks.b, tracks[1] || tracks[0], {paused:true});
    markActive(decks.a);
    status(tracks.length + '-record Shopify CDN set · ready');
  }
  applyMix();

  if ('IntersectionObserver' in global) {
    loopObserver = new IntersectionObserver(function (entries) {
      var visible = entries.some(function (entry) { return entry.isIntersecting; });
      if (visible && !document.hidden) startVisualLoop();
      else stopVisualLoop();
    }, { rootMargin: '200px 0px' });
    loopObserver.observe(consoleNode);
  } else {
    startVisualLoop();
  }
  listen(document, 'visibilitychange', function () {
    if (document.hidden) { stopVisualLoop(); return; }
    if (!loopObserver) { startVisualLoop(); return; }
    var rect = consoleNode.getBoundingClientRect();
    if (rect.bottom > 0 && rect.top < global.innerHeight) startVisualLoop();
  });

  var renderText = function () {
    var x = clamp(crossfader / 100, 0, 1);
    return JSON.stringify({mode:'dj-deck',tracks:tracks.length,activeDeck:activeDeckKey,crossfader:Math.round(crossfader),mix:{a:Number((decks.a.volume * Math.cos(x * Math.PI / 2)).toFixed(3)),b:Number((decks.b.volume * Math.sin(x * Math.PI / 2)).toFixed(3))},autoMixBusy:autoMixInProgress,autoPlay:autoPlay,quickLoad:{genre:quickLoadGenre,ids:quickLoadIds.slice()},playlist:playlist.slice(),decks:{a:snapshotDeck(decks.a),b:snapshotDeck(decks.b)}});
  };
  global.render_game_to_text = renderText;

  return function release() {
    if (disposed) return;
    saveSession();
    disposed = true;
    stopVisualLoop();
    if (loopObserver) loopObserver.disconnect();
    pendingTimers.forEach(cancelLater);
    pendingTimers.clear();
    global.clearInterval(autoMixTimer);
    removers.forEach(function (remove) { remove(); });
    removers.length = 0;
    Object.keys(decks).forEach(function (key) {
      var deck = decks[key];
      deck.audio.pause();
      deck.audio.removeAttribute('src');
      deck.audio.load();
      [deck.source, deck.filterNode, deck.analyser, deck.gainNode].forEach(function (node) {
        if (node) { try { node.disconnect(); } catch (_) {} }
      });
    });
    [masterGain, compressor].forEach(function (node) {
      if (node) { try { node.disconnect(); } catch (_) {} }
    });
    if (audioContext && audioContext.state !== 'closed') audioContext.close().catch(function () {});
    if (document.fullscreenElement && root.contains(document.fullscreenElement) && document.exitFullscreen) {
      var exit = document.exitFullscreen();
      if (exit && exit.catch) exit.catch(function () {});
    }
    document.body.classList.remove('dj-deck-page', 'dj-drawer-open', 'dj-performance-mode');
    if (global.render_game_to_text === renderText) {
      if (previousTextRenderer) global.render_game_to_text = previousTextRenderer;
      else delete global.render_game_to_text;
    }
  };
  }

  global.SpatialxDjDeck = { mount: mount, destroy: destroy };
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
  mount(document);
})(window);
